/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import PaginatedListState, { type PaginatedListParams } from 'flarum/common/states/PaginatedListState';
import type Bookshelf from '../../common/models/Bookshelf';

export default class HomeBookshelvesLeaderboardState extends PaginatedListState<Bookshelf> {
	// Re-declared public so the state can be instantiated with `new` (TS2674).
	public constructor(params?: PaginatedListParams, page?: number, pageSize?: number) {
		super(params, page, pageSize);
	}

	get type(): string {
		return 'of/active_bookshelves';
	}
}
